import FontFaceObserver from 'fontfaceobserver';
import { Fonts, Font } from 'mm-theme-configuration/dist/interfaces';
import { createFVDKey, getStyle, parseVariant } from './webFonts.utils';

interface FontObservers {
    [key: string]: Promise<void>;
}

export class WebfontLoader {
  fonts: Fonts;

  constructor(fonts: Fonts) {
    this.fonts = fonts;
  }

  createFontObserver = (family: string, variant: string) => {
    const { weight, style } = parseVariant(variant);
    return new FontFaceObserver(
      family,
      {
        weight: weight || variant,
        style: getStyle(style),
      },
    ).load();
  };

  observeFontLoading() {
    const { fonts } = this;
    const fontObservers = {} as FontObservers;
    fonts.forEach((font: Font) => {
      const { family, variants } = font;
      variants.forEach((variant: string) => {
        const fvd = createFVDKey(family, variant);
        const fontVariantObserver = this.createFontObserver(family, variant);
        fontObservers[fvd] = fontVariantObserver;
      });
    });
    return Promise.all(Object.values(fontObservers));
  }
}
